// src/api/axios.js
import axios from "axios";
import store from "../redux/store";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:4000",
  baseURL: "https://adminpanel.defencehousingsociety.com",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  },
);

export default axiosInstance;
